<template>
  <div class="main-setting-menu">
    <HeaderMenu :title="$t('mainTools.title')" :routeBackName="routeBackName" />
    <ul class="list-main-setting list-menu">
      <!--  <li class="item">
        <RowItem
          @click="openEncyclopPopup"
          :title="$t('mainTools.encyclopedia')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        >
          <div
            style="display: flex;
    align-items: center;
    justify-content: center;"
          >
            <img src="~@/assets/img/en_menu.png" alt />
          </div>
        </RowItem>
      </li> -->
      <li class="item">
        <RowItem
          @click="openMainKeys"
          :title="$t('mainTools.keys')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="8"
        />
      </li>
      <li class="item" v-hide.online>
        <RowItem
          v-kiosk
          v-disable
          @click="openCreateBook"
          :title="$t('mainTools.createMineBook')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="x"
        />
      </li>
      <!--  <li class="item">
        <RowItem
          v-kiosk
          @click="goToHistory"
          :title="$t('mainTools.historyName')"
          :HasIconItem="true"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="p"
        />
        <router-view />
      </li> -->
      <!--       <li class="item">
        <RowItem
          v-kiosk
          @click="goToPersonalExtensions"
          :title="$t('mainTools.personalExtensionsName')"
          :HasIconItem="true"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="q"
        />
        <router-view />
      </li> -->

      <li class="item">
        <RowItem
          v-kiosk
          @click="goToDesktop"
          :title="$t('mainTools.desktopName')"
          :HasIconItem="true"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="t"
        />
        <router-view />
      </li>
      <!-- <li class="item" v-hide.online>
        <RowItem
          @click="goToPdDpi"
          :title="$t('general.dpiSetting')"
          :HasIconItem="true"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="w"
        />
        <router-view />
      </li> -->
      <li class="item" v-hide.online>
        <RowItem
          v-kiosk
          v-disable
          @click="enableBackup"
          :title="$t('mainTools.enableBackupName')"
          :HasIconItem="true"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="u"
        />
        <!-- :buttonName="$t('mainTools.active')" -->
        <router-view />
      </li>
      <!--  <li class="item" v-remove.online>
        <RowItem
          v-kiosk
          v-disable
          @click="refreshList"
          :title="$t('mainTools.refreshListName')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="true"
          :HasIconCheckbox="false"
          iconItem="v"
          :buttonName="$t('mainTools.refresh')"
        />
      </li> -->
      <!--   <li class="item" v-remove.online>
        <RowItem
          v-disable
          @click="
            $show_oks();
            closeMenu();
          "
          :title="$t('mainTools.keyboardOnScreen')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        >
          <BaseIcon class="" width="25" nameIcon="keyboard" pathIcon="k" />
        </RowItem>
      </li> -->
      <li class="item" v-remove.online v-if="false">
        <RowItem
          v-disable
          @click="
            openCalDialog();
            closeMenu();
          "
          :title="$t('mainTools.updateCalender')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        >
          <BaseIcon class="" width="19" nameIcon="calendar" pathIcon="k" />
        </RowItem>
        <BaseExplorer
          :showfiles="true"
          v-if="showFileExplore"
          @close="showFileExplore = false"
          @selected="updateCal"
        />
        <!-- <input
          @change="updateCal"
          ref="upbutton"
          type="file"
          style="display:none"
        /> -->
      </li>
      <li class="item" v-hide.online>
        <RowItem
          v-disable
          v-kiosk
          @click="goToChangeBookInfo"
          :title="$t('mainTools.changeBookInfoName')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="w"
        />
        <router-view />
      </li>
      <li class="item" v-remove.online>
        <RowItem
          v-kiosk
          v-disable
          @click="showImportOldVersData"
          :title="this.$t('importData.title')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="x"
        />
      </li>
      <!-- <li class="item">
        <RowItem
          v-disable
          @click="showMenuShortcuts"
          :title="this.$t('shortcutKeysMenu.title')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        >
          <BaseIcon class="" width="25" nameIcon="keyboard" pathIcon="k" />
        </RowItem>
      </li> -->
      <!-- <li class="item" v-remove.online v-kiosk.remove>
        <RowItem
          @click="createMemSnapshot"
          :title="this.$t('mainTools.memSnap')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="j"
        >
        </RowItem>
      </li> -->
      <li class="item" v-remove.online>
        <RowItem
          @click="showOpenBook"
          :title="this.$t('mainTools.openBookFromLink')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="x"
        >
          <!-- <BaseIcon class="" width="25" nameIcon="keyboard" pathIcon="k" /> -->
        </RowItem>
      </li>
      <li class="item" v-remove.online v-kiosk.remove>
        <RowItem
          v-disable
          @click="showMenuAppUpdates"
          :title="this.$t('updates.appUpdates')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="t"
        >
        </RowItem>
      </li>

      <li class="item" v-version.up="21">
        <RowItem
          @click="openGimCalculator"
          :title="$t('gimatriaTool.title')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="x"
        >
        </RowItem>
      </li>
      <li class="item" v-kiosk.remove>
        <RowItem
          @click="clearCaches"
          :title="$t('general.clearCache')"
          :HasIconItem="true"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
          iconItem="v"
        >
        </RowItem>
      </li>
    </ul>
  </div>
</template>

<script>
import * as advLocalStorage from "localforage";
import menuService from "@/services/menu";
import { doHardReload } from "@/services/bookData";
import { mapGetters, mapActions } from "vuex";
import { Axios } from "@/services/_axios";
import { IPUserNoPersDataMsg } from "@/services/userBooksData.js";

export default {
  //historyLists/Hitory
  components: {},
  data() {
    return {
      routeBackName: "menu-options",
      historyIcon: "fa fa-history",
      genderlessIcon: "fa fa-genderless",
      customPigeonsIcon: "fa fa-bullseye",
      desktopIcon: "fa fa-television",
      enableBackupIcon: "fa fa-floppy-o",
      refreshListIcon: "fa fa-refresh",
      changeBookInfoIcon: "fa fa-book",
      showFileExplore: false,
    };
  },
  computed: {
    //getviewPlaces
    ...mapGetters("user", ["isIPLimited", "getSubUserData"]),
    ...mapGetters("userSetting", ["getviewPlaces"]),
  },
  methods: {
    ...mapActions("encyclopedia", ["setclosePopup", "setVisible"]),
    ...mapActions("createBook", ["showCreate"]),
    ...mapActions("systemKeys", ["setShowKeys", "setCloseKeys"]),
    // Encyclopedia
    /*  openEncyclopPopup() {
      this.setVisible();
      menuService.closeMenu();
    }, */
    async createMemSnapshot() {
      this.$notify({
        type: "success",
        message: this.$t("mainTools.memSnapStart"),
        timeout: 2000,
      });
      const ret = await Axios.get("/api/general/mem-snapshot");
      if (ret.status) {
        this.$notify({
          type: "success",
          message: this.$t("mainTools.memSnapEndSuccessful"),
          timeout: 2000,
        });
      } else {
        this.$notify({
          type: "success",
          message: this.$t("mainTools.memSnapEndUnsuccessful"),
          timeout: 2000,
        });
      }
      menuService.closeMenu();
    },
    closeMenu() {
      menuService.closeMenu();
    },
    openMainKeys() {
      this.setShowKeys();
      menuService.closeMenu();
    },
    async clearCaches() {
      localStorage.clear();
      advLocalStorage.clear();
      const data = await Axios.get("/api/general/clearcache");
      if (data.data === true) {
        const notification = {
          type: "success",
          message: this.$t("general.restartOnSuccess"),

          timeout: 2000,
        };
        this.$notify(notification);
      } else {
        const notification = {
          type: "error",
          message: this.$t("general.error_action") + " : " + data.data,

          timeout: 5000,
        };
        this.$notify(notification);
      }
      this.closeMenu();
    },
    openCreateBook() {
      this.showCreate();
      menuService.closeMenu();
      // this.$router.push({ name: "home" });
    },
    //history
    /*     goToHistory() {
      // this.$router.push({ name: "history" });
      menuService.openHistoryMenu();
    }, */
    //personal-extensions
    goToPersonalExtensions() {
      // this.$router.push({ name: "personal-extensions" });
      menuService.openPersonalExtenMenu();
    },

    goToPdDpi() {
      menuService.openAt("dpi-settings");
    },
    //desktop-settings
    goToDesktop() {
      // this.$router.push({ name: "desktop-settings" });
      menuService.openDesktopsMenu();
    },
    enableBackup() {
      menuService.openBackup();
    },
    refreshList() {
      doHardReload();
      menuService.closeMenu();
    },
    goToChangeBookInfo() {
      // this.$router.push({ name: "books-info-settings" });
      menuService.openBooksInfoMenu();
    },

    ffff() {},
    openCalDialog() {
      this.showFileExplore = true;
    },
    async updateCal(file) {
      this.showFileExplore = false;

      if (!file.endsWith("zip") || !file.includes("update_cal_")) {
        const notification = {
          type: "error",
          message: this.$t("mainTools.fileError"),

          timeout: 2000,
          setting: {
            grid: "icon",
            nameIcon: "icon-save-win",
            position: "center",
          },
        };
        this.$notify(notification);
      } else {
        try {
          let data = await Axios.post("api/general/calender", {
            data: file,
          });
          const notification = {
            type: "success",
            message: this.$t("mainTools.succeedUpdateBoard"),
            timeout: 2000,
          };
          this.$notify(notification);
        } catch {
          const notification = {
            type: "error",
            message: this.$t("mainTools.fileError"),
            timeout: 2000,
          };
          this.$notify(notification);
        }
      }
      menuService.closeMenu();
      // }
    },
    showImportOldVersData() {
      this.$store.dispatch("importOldVersData/showWin", true);

      menuService.closeMenu();
    },
    showMenuShortcuts() {
      menuService.openShortcutsMenu();
    },
    showMenuAppUpdates() {
      menuService.openAppUpdatesMenu();
    },
    showOpenBook() {
      menuService.openOpenBook();
    },
    openGimCalculator() {
      this.$store.dispatch("gimCalculator/setVisible");
      menuService.closeMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-item {
  font-family: menu;
  font-size: 60px;
  text-align: center;
  height: 33px;
  line-height: 33px;
  color: #626262;
  margin-left: 15px;
}
.main-setting-menu {
  width: -webkit-fill-available;
  z-index: 3;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.list-main-setting {
  display: flex;
  flex-direction: column;
  // margin: 0;
  // padding: 0;
  list-style-type: none;
}
</style>
